module.exports = "\n\n<iframe #glossaryiframe src=\"web/epeopledoc/ePeople/_build/html/genindex.html\" (load)=\"changeLink(glossaryiframe);\"></iframe>"